import React, { useContext } from "react";
import PropTypes from "prop-types";

import { ReactComponent as LeftArrowSvg } from "../../../assets/header/left-arrow.svg";
import AppContext from "../../../AppContext";
import { langComponent } from "../../../constants";
import { useNavigate } from "react-router-dom";

const NavBarItem = ({ title, to, items }) => {
  const { toggleNavbar, getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.header);
  const navigate = useNavigate();

  const handleClickHeader = () => {
    if (to === undefined) {
      return;
    }

    toggleNavbar();
    navigate(to);
  };

  const handleClickItem = (to) => {
    toggleNavbar();
    navigate(to);
  };

  return (
    <div className="navbar-content-menu">
      <div className="navbar-content-menu__title" onClick={handleClickHeader}>
        {title}
      </div>
      {items?.map((item) => {
        return (
          <div
            className="navbar-content-menu-list"
            key={item.title}
            onClick={() => handleClickItem(item.to)}
          >
            <div className="navbar-content-menu-list__item">{item.title}</div>
          </div>
        );
      })}
    </div>
  );
};

const NavBar = (props) => {
  const { toggleNavbar, getLang } = useContext(AppContext);
  const Translation = getLang(langComponent.header);

  return (
    <div className="navbar">
      <div className="navbar-header">
        <span className="navbar-header__title">{Translation("Menus")}</span>
        <LeftArrowSvg
          className="navbar-header__arrow"
          height={18}
          onClick={() => toggleNavbar()}
        />
      </div>
      <div className="navbar-subtitle">{Translation("Pages")}</div>
      <div className="navbar-content">
        <NavBarItem title={Translation("Home")} to="/" />
        <NavBarItem
          title={Translation("Art & Design")}
          items={[
            { title: "Community Space", to: "/art-designs/community-spaces" },
            { title: "Work Exchanges", to: "/art-designs/work-exchanges" },
          ]}
        />
        <NavBarItem title={Translation("Tendering")} to="/tenderings" />
        <NavBarItem title={Translation("Blogs")} to="/blogs" />
        <NavBarItem
          title={Translation("Support")}
          items={[
            {
              title: Translation("Support Tickets"),
              to: "/support/ticketstickets",
            },
            { title: Translation("FAQs"), to: "/support/faqs" },
          ]}
        />
      </div>
    </div>
  );
};

NavBar.propTypes = {};

export default NavBar;
